import { Performer } from '../core/performer'
import { HttpMethod } from '../core/types'

export class AssignShift extends Performer<
  {
    payload: {
      chatterId: number
      date: Date
      isIntern: boolean
      time: string
    }
  },
  number
> {
  protected method = HttpMethod.POST
  protected url = '/shifts/assign'
}

export default new AssignShift().perform
